import { MusicTiming } from './MusicTiming';
export class RampingTempoTiming extends MusicTiming {
    signature;
    startTimestamp;
    startTempo;
    endTempo;
    startMeasure;
    endMeasure;
    _endTimestamp;
    startValue;
    endValue;
    slope;
    startIntegral;
    constructor(signature, startTimestamp, startTempo, endTempo, startMeasure, endMeasure) {
        super(signature);
        this.signature = signature;
        this.startTimestamp = startTimestamp;
        this.startTempo = startTempo;
        this.endTempo = endTempo;
        this.startMeasure = startMeasure;
        this.endMeasure = endMeasure;
        this.startValue = this.startMeasure * this.measureValue;
        this.endValue = (this.endMeasure + 1) * this.measureValue;
        this.slope = this.notesPerSecond(this.endTempo - this.startTempo) / (this.endValue - this.startValue);
        this.startIntegral = this.integrateXdx(this.startValue);
        this._endTimestamp = this.startTimestamp + this.integrateXdx(this.endValue) - this.startIntegral;
    }
    get duration() {
        return this.endMeasure - this.startMeasure;
    }
    secondsPerNote(tempo) {
        return (60 * this.tickNote) / tempo;
    }
    notesPerSecond(tempo) {
        return tempo / (60 * this.tickNote);
    }
    timestamp(realValue) {
        if (realValue < this.startValue) {
            return this.startTimestamp + (realValue - this.startValue) * this.secondsPerNote(this.startTempo);
        }
        else if (realValue > this.endValue) {
            return this._endTimestamp + (realValue - this.endValue) * this.secondsPerNote(this.endTempo);
        }
        else {
            return this.startTimestamp + this.integrateXdx(realValue) - this.startIntegral;
        }
    }
    realValue(timestamp) {
        if (timestamp < this.startTimestamp) {
            return this.startValue + (timestamp - this.startTimestamp) * this.notesPerSecond(this.startTempo);
        }
        else if (timestamp > this._endTimestamp) {
            return this.endValue + (timestamp - this._endTimestamp) * this.notesPerSecond(this.endTempo);
        }
        else {
            const c = this.notesPerSecond(this.startTempo);
            const a = this.slope;
            return c * (Math.exp(a * (timestamp - this.startTimestamp)) - 1) / a;
        }
    }
    tempo(realValue) {
        if (realValue < this.startValue) {
            return this.startTempo;
        }
        else if (realValue > this.endValue) {
            return this.endTempo;
        }
        else {
            const nps = this.notesPerSecond(this.startTempo) + (realValue - this.startValue) * this.slope;
            return nps * 60 * this.beatNote;
        }
    }
    tempoAt(timestamp) {
        return this.tempo(this.realValue(timestamp));
    }
    tickTempo(tick) {
        return this.tempo(tick / this.tickNote);
    }
    tickLength(tick) {
        return this.tickTimestamp(tick + 1) - this.tickTimestamp(tick);
    }
    integrateXdx(realValue) {
        const c = this.notesPerSecond(this.startTempo);
        const a = this.slope;
        return Math.log(a * realValue + c) / a;
    }
    get firstTick() {
        return this.startValue * this.tickNote;
    }
    get lastTick() {
        return (this.endValue) * this.tickNote - 1;
    }
}
//# sourceMappingURL=RampingTempoTiming.js.map